module.exports = __webpack_public_path__ + "img/back-sd.8ecd041b.png";